// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js!../../styles.global.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
exports.push([module.id, ".servicensw-embed {\n  visibility: hidden;\n}\n.servicensw-embed img {\n  max-height: 49px;\n}\n.servicensw-embed.loaded-header {\n  visibility: visible;\n}\n\n.hideElement {\n  display: none !important;\n}\n", ""]);
// Exports
module.exports = exports;
